import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$2 } from './form-control-error-text2.js';
import { d as defineCustomElement$1 } from './form-control-help-text2.js';

const CheckboxInput = /*@__PURE__*/ proxyCustomElement(class CheckboxInput extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.formControlInput = createEvent(this, "formControlInput", 7);
        this.formControlBlur = createEvent(this, "formControlBlur", 7);
        this.handleFormControlInput = (event) => {
            const target = event.target;
            const name = target.getAttribute('name');
            this.inputHandler(name, target.checked);
            this.formControlInput.emit({ name, value: target.value });
        };
        this.updateInput = (newValue) => {
            this.checkboxElement.checked = newValue;
        };
        this.label = undefined;
        this.name = undefined;
        this.helpText = undefined;
        this.errorText = undefined;
        this.defaultValue = undefined;
        this.inputHandler = undefined;
        this.disabled = undefined;
    }
    handleDefaultValueChange(newValue) {
        this.updateInput(newValue);
    }
    componentDidLoad() {
        this.updateInput(this.defaultValue);
    }
    render() {
        return (h(Host, { key: 'c3d33e4a76472bb4143720251d1213a47642552c', exportparts: "label,input,input-invalid" }, h("div", { key: '68988cb5e01923e04917a83bd936dc76374c4f42', class: 'form-group d-flex flex-column' }, h("div", { key: '308d9016c2b542b82d3bebcdd2ea431ba537d165', class: "form-check" }, h("input", { key: '16dd03704fc680d380e648655fd1acd6fce3e75a', ref: el => (this.checkboxElement = el), type: "checkbox", id: this.name, name: this.name, onBlur: this.formControlBlur.emit, onInput: this.handleFormControlInput, part: `input-checkbox ${this.errorText ? 'input-checkbox-invalid' : ''}`, class: this.errorText ? 'form-check-input is-invalid' : 'form-check-input', disabled: this.disabled }), h("label", { key: '4d344d2b87a29f87615f84127aa4209d3bbb5b6b', class: "form-check-label", htmlFor: this.name }, this.label)), h("form-control-help-text", { key: '254147b71ed57277c010aaa9a38a4cc923634896', helpText: this.helpText, name: this.name }), h("form-control-error-text", { key: '3fac926a8a1c08a7fe8f97f4610fbbc97716f10e', errorText: this.errorText, name: this.name }))));
    }
    static get watchers() { return {
        "defaultValue": ["handleDefaultValueChange"]
    }; }
}, [0, "form-control-checkbox", {
        "label": [1],
        "name": [8],
        "helpText": [1, "help-text"],
        "errorText": [1, "error-text"],
        "defaultValue": [4, "default-value"],
        "inputHandler": [16],
        "disabled": [4]
    }, undefined, {
        "defaultValue": ["handleDefaultValueChange"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["form-control-checkbox", "form-control-error-text", "form-control-help-text"];
    components.forEach(tagName => { switch (tagName) {
        case "form-control-checkbox":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CheckboxInput);
            }
            break;
        case "form-control-error-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-help-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { CheckboxInput as C, defineCustomElement as d };
